<template>
    <main class="content prolongation">
      <prolongationExpress />
    </main>
</template>

<script>
import prolongationExpress from '@/components/prolongationExpress.vue'
export default {
  name: 'Prolongation',
  components: { prolongationExpress }
}
</script>
<style scoped>
.prolongation {
  padding-top: 60px;
}

@media (max-width: 767px) {
  .prolongation {
    padding-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Prolongation.vue